<template>
  <div>
    <p class="msg" style="margin: 0px;">
      <awesomeIcon icon="exclamation-circle" />
      {{ $parent.role === '2'
        ? `Hier ziet u berekeningen die u heeft gemaakt die u nog niet aan uw klant heeft gekoppeld.
          Uiteraard kunt u deze alsnog koppelen, aanpassen of verwijderen.`
        : 'Nog niet gealloceerde doelen'
      }}
    </p>
    <div class="card" v-if="$parent.intakes !== null">
      <div class="row menubar">
        <input
          type="text"
          v-model="search"
          ref="search"
          placeholder="Zoeken"
          @keyup="updateSearch"
          class="searchbar"
        />
      </div>
      <table width="100%">
        <thead class="table-legend">
          <tr>
            <th>ID</th>
            <th>Naam</th>
            <th>Startbedrag</th>
            <th>Doeltype</th>
            <th></th>
          </tr>
        </thead>
        <tr
          v-for="(intake, index) in slice(
            filter(intakes, searchFilter),
            currentPage * resultsPerPage, (
              currentPage + 1
            ) * resultsPerPage
          )"
          :key='`client${index}intake${intake.id}`'
        >
          <td>
            <span class="grey concat" :title="`ID: #${intake.id}`">{{ intake.id }}</span>
          </td>
          <td v-if="$parent.typeToATPGoal(intake) === 'Zakelijke beleggingsrekening'">
            <span class="concat" :title="`Naam bedrijf: ${intake.companyName}`">
              {{ intake.companyName}}
            </span><br />
            <span class="grey concat" :title="`Naam: ${intake.totalName}`">
              {{ intake.totalName}}
            </span>
          </td>
          <td v-else>
            <span>
              {{ intake.totalName }}
            </span>
          </td>
          <td>
            Startbedrag:
            <span class="grey concat">
              € {{intake.vermogen ? formatPrice(intake.vermogen, true) : '-'}}
            </span>
          </td>
          <td>
            Doeltype:
            <span class="grey concat"> {{ $parent.typeToATPGoal(intake) }}</span>
          </td>
          <td style="float:right;">
            <button
              @click="openIntake(intake.id)"
              class="secondary hide-mobile"
              style="margin-top: 10px;"
              title="Bekijk doel"
            >
              <awesomeIcon icon="search"/> Bekijk
            </button>
          </td>
          <td style="float:right;">
            <button
              @click="stopIntake(intake.id)"
              class="secondary hide-mobile"
              style="margin-top: 10px;"
              title="Verwijder doel"
            >
              <awesomeIcon icon="trash"/> Verwijderen
            </button>
          </td>
        </tr>
      </table>
      <pagerElement
        v-model="currentPage"
        :records="filter(intakes, searchFilter).length"
        :resultsPerPage="resultsPerPage"
      />
    </div>
  </div>
</template>

<script>
import { filter, slice } from 'lodash-es';

export default {
  name: 'ConceptIntakes',
  data() {
    return {
      search: '',
      dropdownlist: false,
      currentPage: 0,
      resultsPerPage: 10,
    };
  },
  computed: {
    intakes() {
      const intakesArray = [];
      for (let i = 0; i < this.$parent.conceptIntakes.length; i += 1) {
        const intake = this.$parent.conceptIntakes[i];

        let values = {};
        let adminValues = {};
        try {
          values = JSON.parse(intake.intake || '{}');
        } catch (e) {
          // eslint-disable-next-line
          console.log(`Intake ${intake.id} failed to parse intake`);
        }
        try {
          adminValues = JSON.parse(intake.admin || '{}');
        } catch (e) {
          // eslint-disable-next-line
          console.log(`Intake admin ${intake.id} failed to parse intake`);
        }

        let firstName = '';
        if (values.persoonsData[0].roepnaam) {
          firstName = values.persoonsData[0].roepnaam;
        } else if (values.persoonsData[0].voorletters) {
          firstName = values.persoonsData[0].voorletters;
        } else if (values.persoonsData[0].voornaam) {
          firstName = values.persoonsData[0].voornaam;
        }
        const combinedName = `${firstName} ${values.persoonsData[0].tussenvoegsel || ''} ${values.persoonsData[0].achternaam || ''}`;
        if (intake.status === 'Bezig') {
          let goal = '?';
          if (values.goalData) {
            if (values.rekeningData.type === 'Bedrijfsrekening' && values.goalData.type === 'vermogensopbouw') {
              goal = 'Bedrijfsrekening';
            } else {
              goal = values.goalData.type;
            }
          }
          intakesArray.push({
            id: intake.id,
            totalName: combinedName,
            companyName: (goal === 'Bedrijfsrekening' && values.bedrijfsData)
              ? values.bedrijfsData.bedrijfsnaam
              : '',
            name: intake.name,
            status: intake.status,
            atpData: values.atpData ? values.atpData : {},
            goal,
            box: values.goalData ? `${values.goalData.box}` : '?',
            brand: adminValues.beleggen ? `${adminValues.beleggen.brand}` : '',
            vermogen: values.goalData ? Number(values.goalData.vermogen || 0) : 0,
            value: intake.value,
            start: adminValues.start ? adminValues.start : '',
          });
        }
      }
      return intakesArray;
    },
  },
  methods: {
    slice,
    filter,
    openIntake(id) {
      window.location.href = `?intake=${id}`;
    },
    stopIntake(id) {
      this.$store.state.confirm.toggle({
        text: 'Weet u zeker dat u dit doel wilt annuleren?',
        cb: (confirmed) => {
          if (confirmed) {
            this.sdk.deleteIntake(id, () => {
              this.sdk.getIntakes((response) => {
                this.$store.state.intakes = response.data;
                this.$parent.getConceptIntakes();
              });
            });
          }
        },
      });
    },
    chooseOrder(group) {
      this.dropdownlist = false;
      this.order = group;
    },
    updateSearch() {
      this.currentPage = 0;
      this.search = this.$refs.search.value.toLowerCase();
    },
    searchFilter(obj) {
      const trimmedSearch = this.search.trim();
      if (String(obj.id).indexOf(trimmedSearch) > -1) {
        return true;
      }
      if (this.$parent.typeToATPGoal(
        obj,
      ).toLowerCase().indexOf(trimmedSearch) > -1) {
        return true;
      }
      if (this.formatPrice(
        obj.score,
        true,
      ).indexOf(trimmedSearch) > -1) {
        return true;
      }
      return false;
    },
  },
};
</script>
<style lang="scss" scoped>
.tableMsg {
  padding: 10px 20px;
  position: relative;
  overflow: hidden;
  color: #664d03;
  background-color: #fff3cd;
  margin: 2px 0;
  border-radius: $br;
}
</style>
